<template>
  <div>
    <!-- 添加弹框 -->
    <sys-dialog
      :title="messageDialog.title"
      :width="messageDialog.width"
      :height="messageDialog.height"
      :visible="messageDialog.visible"
      @onConfirm="messageConfirm"
      @onClose="messageClose">
      <div slot="content" class="message-text">
        <div class="examin_mian">
            <div class="examin_head">
                <el-form label-position="right" label-width="80px" :model="formLabelAlign" ref="formLabelAlign">
                  <el-form-item label="姓名：" prop="realName">
                    <el-input v-model.trim="formLabelAlign.realName" placeholder="请输入考生姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="账号：" prop="userName">
                    <el-input v-model.trim="formLabelAlign.userName" placeholder="请输入考生账号"></el-input>
                </el-form-item>
                <el-form-item label="科室：" prop="departmentName">
                  <el-select v-model="formLabelAlign.departmentName" clearable placeholder="全部" @change="searchChang">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in keshioptions" :key="item.DepartmentID" :label="item.DepartmentName" :value="item.DepartmentName"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="职称：" prop="pTitle">
                  <el-select v-model="formLabelAlign.pTitle" placeholder="全部" @change="searchChang">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in zhichengoptions" :key="item.PTitle" :label="item.PTitle" :value="item.PTitle"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="职位：" prop="position">
                  <el-select v-model="formLabelAlign.position" placeholder="全部" @change="searchChang">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in zhiweioptions" :key="item.Position" :label="item.Position" :value="item.Position"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态：" prop="userExamType">
                  <el-select v-model="formLabelAlign.userExamType" clearable placeholder="全部" @change="searchChang">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="不及格" value="0"></el-option>
                    <el-option label="及格" value="1"></el-option>
                    <el-option label="未参加" value="2"></el-option>
                  </el-select>
                </el-form-item>
                </el-form>
                <div class="query_btn">
                  <el-button
                  type="primary"
                  icon="el-icon-search"
                  class="searchbtn"
                  @click="searchBtn"
                  >搜索</el-button
                  >
                  <el-button
                  icon="el-icon-refresh"
                  class="searchbtn sonbtn"
                  @click="resetForm('formLabelAlign')"
                  >重置</el-button
                  >
                </div>
            </div>
            <div class="examinee_form">
              <p class="">已选{{ this.selectUserList.length }}人，科室{{ this.unique() }}个</p>
              <!-- 表格内容 -->
              <sys-box-table ref="sysBoxTable"
                             :tableList="examStudentListTable"
                             rowKey="userID"
                             :showIndex="true"
                             :showOperation="false"
                             :columList="formColumns"
                             @handleSelectionChange="handleSelectionChange"
                             v-loading="tableLoading">
              </sys-box-table>
            </div>
          <!-- 分页 -->
          <div class="footBox">
            <div class="footPage">
              <p>
                共有{{ pageParms.total }}条记录
              </p>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageParms.currentPage"
                :page-size="pageParms.pageSize"
                :page-sizes="pageParms.pagesizesArr"
                layout="prev, pager, next, sizes, jumper"
                :total="pageParms.total"
                class="pagination">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </sys-dialog>
  </div>
</template>

<script>
import $monitor from "@/api/monitor.js";
import SysBoxTable from "@/components/system/SysBoxTable";
import SysDialog from "@/components/system/SysDialog";
export default {
  components: {
    SysBoxTable,
    SysDialog
  },
  data() {
    return {
      pageParms:{
        // 当前页
        currentPage: 1,
        pageSize: 6,
        pagesizesArr: [5, 10, 20, 50, 100],
        // 总数量
        total: 100,
      },
      tableLoading:false,
      messageDialog:{
        title:"添加考生",
        width:1400,
        height:600,
        visible:false
      },
      keshioptions:[],//科室
      zhichengoptions:[],//职称
      zhiweioptions:[],//职位
      formLabelAlign: {
        realName: "", //考生姓名
        userName: "", //考生账号
        departmentName: "", //科室
        pTitle:"",//职称
        position: "", //职位
        userExamType:"",//状态位
      },
      formColumns: [
        {
          prop: "RealName",
          lable: "考生姓名",
          width:"",
          align:"center"
        },
        {
          prop: "UserName",
          lable: "考生账号",
          width:"",
          align:"center"
        },
        {
          prop: "DepartmentName",
          lable: "科室名称",
          width:"",
          align:"center"
        },
        {
          prop: "PTitle",
          lable: "职称",
          width:"",
          align:"center"
        },
        {
          prop: "Position",
          lable: "职位",
          width:"",
          align:"center"
        },
        {
          prop: "Birthday",
          lable: "出生日期",
          width:"",
          align:"center",
          type:"date"
        },
        {
          prop: "userExamType",
          lable: "考试状态",
          width:"",
          align:"center",
        },
        {
          prop: "JobDate",
          lable: "工作年限",
          width:"",
          align:"center"
        },
      ],
      examStudentListTable:[],//考生列表展示列表上
      selectUserIds:[],//选中的userId
      selectUserList:[],//选中的user对象
    };
  },
  methods: {
    UtilFun:function(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    getExamStudentList:async function(){
      console.log("selectUserList=========",this.selectUserList)
      this.tableLoading = true;
      let parms = {};
      parms = this.formLabelAlign;
      parms.examID = this.$parent.$parent.newExamInfo.ExamID;
      parms = this.UtilFun(parms);
      parms.PageIndex = this.pageParms.currentPage - 1;
      parms.PageShow = this.pageParms.pageSize;
      let { data } = await $monitor.makeUpExamUserList(parms);
      if(data.Status === 200){
        this.examStudentListTable = data.Data.data[0];
        this.pageParms.total = data.Data.data[1][0].total;
        this.keshioptions = data.Data.data[2];
        this.keshioptions = this.keshioptions.filter(keshi=>{
          return keshi.DepartmentName !="" && keshi.DepartmentName != null
        });
        this.zhichengoptions = data.Data.data[3];
        this.zhichengoptions = this.zhichengoptions.filter(zhicheng=>{
          return zhicheng.PTitle !="" && zhicheng.PTitle != null
        });
        this.zhiweioptions = data.Data.data[4];
        this.zhiweioptions = this.zhiweioptions.filter(zhiwei=>{
          return zhiwei.Position !="" && zhiwei.Position != null
        })
      }else{
        this.$message.error("获取考生信息失败！");
      }
      setTimeout(() => {
        this.tableLoading = false;
      }, 200);
    },
    handleSelectionChange:function(data){
      this.selectUserIds = [];
      this.selectUserList = [];
      data.forEach(user =>{
        this.selectUserIds.push(user.UserID);
        this.selectUserList.push(user);
      });
    },
    // 显示条数
    handleSizeChange:function(val) {
      this.pageParms.currentPage = 1;
      this.pageParms.pageSize = val;
      this.getExamStudentList();
    },
    // 分页
    handleCurrentChange:function(val) {
      this.pageParms.currentPage = val;
      this.getExamStudentList();
    },
    messageClose:function(){
      this.messageDialog.visible = false;
    },
    messageConfirm:function(){
      if(this.selectUserList.length == 0){
        this.$message.warning("请先勾选考生信息！");
        return;
      }
      let userIds = [];
      this.$parent.examStudentList.forEach(res=>{
        userIds.push(res.userID);
      });
      let filterUserList = this.selectUserList.filter(user=>{
        return userIds.toString().indexOf(user.userID.toString()) == -1
      });
      if(filterUserList.length < this.selectUserList.length){
        this.$message.warning("该考生已添加，请勿重复添加！");
      }
      filterUserList.forEach(res=>{
        this.$parent.examStudentList.push(res);
        this.$parent.examStudentListTable.push(res);
      });
      console.log("filterUserList=====",filterUserList);
      this.messageDialog.visible = false;
      this.$refs.sysBoxTable.handleClearSelection();
    },
    resetForm:function(){
      this.$refs.formLabelAlign.resetFields();
      this.getExamStudentList();
    },
    searchBtn:function(){
      this.getExamStudentList();
    },
    searchChang:function(){
      this.getExamStudentList();
    },
    unique() {
      let departArr = Object.values(this.selectUserList).map((item) => {
          return item.DepartmentName;
        });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
  },
  computed: {
  },
  created() {
    this.getExamStudentList();
  },
};
</script>

<style lang="scss" scoped>
.examin_mian{
  .examin_head {
    padding: 0px 24px 10px 10px;
    display: flex;
      .el-form {
        display: flex;
      }
      .query_btn {
        display: flex;
        .el-button {
          width: 78px;
          height: 40px;
          margin-left: 14px;
        }
      }
  }
  .examinee_form {
    padding: 0px 20px 0px 34px;
    p {
      margin-bottom: 16px;
    }
  }
}
.message-text{
  display: flex;
  i {
    font-size: 16px;
    color: #ffc664;
    margin-right: 10px;
    transform: translateY(4px);
  }
  p {
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    opacity: 1;
  }
}
.footBox {
  position: relative;
  height: 80px;
  .footPage {
    display: flex;
    align-items: center;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
         color: #ffffff;
         background-color: #409eff;
         border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}
</style>
